import comp from "./I18nHOC";
export default comp;
